/* =================================================================
   Traditional Zürich — Variant-IDs Truth Lock
   -----------------------------------------------------------------
   Single source of truth for Shopify Variant-IDs used in cart-permalinks,
   recommendations, advisor logic, and gift-card flows.

   ALLE Werte verifiziert gegen Live-API /products.json am 2026-05-25.
   Änderungen NUR mit Cross-Check via products.json.
   ================================================================= */

window.TZH_VARIANTS = window.TZH_VARIANTS || {
  // ─── Bartpflege Core ───────────────────────────────────────────
  oil:       { id: '44814472478988', handle: 'shave-beard-oil',  price_chf: 55.00, title: 'Shave & Beard Oil' },
  scrub:     { id: '44814456094988', handle: 'beard-scrub',      price_chf: 65.00, title: 'Beard Scrub' },
  treatment: { id: '44814457635084', handle: 'beard-treatment',  price_chf: 39.50, title: 'Beard Treatment' },
  cream:     { id: '44814476574988', handle: 'forming-cream',    price_chf: 29.50, title: 'Forming Cream' },

  // ─── Bartbürsten ───────────────────────────────────────────────
  brush_oval_s:    { id: '44836730765580', handle: 'bartbuerste-oval-klein',         price_chf: 29.50, title: 'Bartbürste oval (klein)' },
  brush_oval_l:    { id: '44836742267148', handle: 'bartbuerste-oval-gross',         price_chf: 39.50, title: 'Bartbürste oval (gross) — medium' },
  brush_griff_s:   { id: '44836709368076', handle: 'bartbuerste-mit-griff-klein',    price_chf: 32.50, title: 'Bartbürste mit Griff (klein)' },
  brush_griff_l:   { id: '44836700389644', handle: 'bartbuerste-mit-griff-gross',    price_chf: 79.00, title: 'Bartbürste mit Griff (gross)' },
  brush_hair_l:    { id: '44836749213964', handle: 'haar-bartbuerste-mit-griff-gross', price_chf: 79.00, title: 'Haar-/Bartbürste mit Griff (gross)' },

  // ─── Bundle (echtes Shopify-Produkt mit 1 Variante) ────────────
  big_beard_box: { id: '44836941234444', handle: 'big-beard-box', price_chf: 149.00, title: 'Beard Box (3-teilig)',
                   bundle_real: true,
                   contains: ['scrub', 'treatment', 'oil'] },

  // ─── Geschenk-Gutschein · 4 Werte + Custom Amount ──────────────
  // Live-API Stand 2026-05-25. CHF 50/100/150/200 sind aktiv und werden behalten.
  // CHF 25 und CHF 75 werden im Admin auf Inventory=0 gesetzt (Order-History bleibt erhalten).
  // CHF 200 + "Custom Amount" decken Geschenke ab 50 bis frei zusammen.
  gift_card: {
    chf50:  { id: '44836858724620', price_chf:  50.00, title: 'CHF 50.00' },
    chf100: { id: '44836858757388', price_chf: 100.00, title: 'CHF 100.00' },
    chf150: { id: '44836874223884', price_chf: 150.00, title: 'CHF 150.00' },
    chf200: { id: '44836874256652', price_chf: 200.00, title: 'CHF 200.00' },
    // chf25  → 44836858691852  · DEAKTIVIERT (Inventory=0)
    // chf75  → 44836874191116  · DEAKTIVIERT (Inventory=0)
    product_handle: 'geschenk-gutschein',
    product_url: '/products/geschenk-gutschein',
    custom_amount_enabled: false // im Admin unter Gift Card Settings togglen
  }
};

/* Cart-Permalink-Helper -----------------------------------------
   Usage:
     TZH.cartPermalink([{key:'oil',qty:1},{key:'brush_oval_l',qty:1}])
       → "/cart/44814472478988:1,44836742267148:1"
   ---------------------------------------------------------------- */
window.TZH = window.TZH || {};
window.TZH.cartPermalink = function(items){
  if(!Array.isArray(items) || items.length === 0) return '/cart';
  var parts = items.map(function(item){
    var v = window.TZH_VARIANTS[item.key];
    if(!v || !v.id) return null;
    var qty = parseInt(item.qty, 10) || 1;
    return v.id + ':' + qty;
  }).filter(Boolean);
  return parts.length > 0 ? ('/cart/' + parts.join(',')) : '/cart';
};

/* Gift-Card-URL-Helper ------------------------------------------
   Usage:
     TZH.giftPermalink('chf100')
       → "/cart/44836858757388:1"
     TZH.giftPermalink()
       → "/products/geschenk-gutschein"  (Fallback: PDP)
   ---------------------------------------------------------------- */
window.TZH.giftPermalink = function(tier){
  var gc = window.TZH_VARIANTS.gift_card;
  if(tier && gc[tier] && gc[tier].id){
    return '/cart/' + gc[tier].id + ':1';
  }
  return gc.product_url || '/products/geschenk-gutschein';
};
